export default {
    languages: {
        ru: {
            code: 'ru',
            name: 'Русский',

            lang_choice_title: 'Добро пожаловать',
            lang_choice_subtitle: 'Выберите свой язык',
        },
        en: {
            code: 'en',
            name: 'English',

            lang_choice_title: 'Welcome',
            lang_choice_subtitle: 'Choose your language',
        },
        uk: {
            code: 'uk',
            name: 'Українська',

            lang_choice_title: 'Ласкаво просимо',
            lang_choice_subtitle: 'Виберіть мову',
        },
        be: {
            code: 'be',
            name: 'Беларуская',

            lang_choice_title: 'Сардэчна запрашаем',
            lang_choice_subtitle: 'Выберыце сваю мову',
        },
        zh: {
            code: 'zh',
            name: '简体中文',

            lang_choice_title: '欢迎',
            lang_choice_subtitle: '选择你的语言',
        },
        pt: {
            code: 'pt',
            name: 'Português',

            lang_choice_title: 'Bem-vindo',
            lang_choice_subtitle: 'Escolhe o teu idioma',
        },
        bg: {
            code: 'bg',
            name: 'Български',

            lang_choice_title: 'Здравейте',
            lang_choice_subtitle: 'Изберете вашият език',
        },
        he: {
            code: 'he',
            name: 'עִברִית',

            lang_choice_title: 'ברוך הבא',
            lang_choice_subtitle: 'בחר את השפה שלך',
        },
        cs: {
            code: "cs",
            name: "Čeština",
      
            lang_choice_title: "Vítejte",
            lang_choice_subtitle: "Vyberte svůj jazyk",
        },
        ro: {
            code: "ro",
            name: "Română",
      
            lang_choice_title: "Bun venit",
            lang_choice_subtitle: "Alegeți limba",
        },
        fr: {
            code: 'fr',
            name: 'Français',

            lang_choice_title: 'Bienvenue',
            lang_choice_subtitle: 'Choisissez votre langue',
        },
    }
}